'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dictionary = require('./classes/Dictionary');

var _Dictionary2 = _interopRequireDefault(_Dictionary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _Dictionary2.default({
  ASSET_SALES: 'Asset Sale',
  HARD_ASSETS: 'Hard Asset',
  ALTERNATIVE_ASSETS: 'Alternative Asset',
  ART_FINANCE: 'Art Finance',
  FUNDS: 'Fund',
  DIRECT_PLACEMENT: 'Direct Placement',
  ACQUISITIONS_AND_DIVESTITURES: 'A&D',
  SECONDARY_SALES: 'Secondary Sale',
  SECURITIZED_TOKEN_OFFERING: 'Digital Financial Instrument',
  REAL_ESTATE: 'Real Estate',
  M_AND_A: 'M&A',
  SERIES_A: 'Series A',
  SERIES_B: 'Series B',
  SERIES_C: 'Series C',
  PRE_SEED: 'Pre-Seed',
  SEED: 'Seed',
  GROWTH: 'Growth',
  CORPORATE_BROKING: 'Corporate Broking',
  DEBT_ADVISORY_RESTRUCTURING: 'Debt Advisory and Restructuring',
  EQUITY_CAPITAL_MARKETS: 'Equity Capital Market',
  FINANCIAL_SPONSORS: 'Financial Sponsor',
  FIXED_INCOME: 'Fixed Income',
  IMPACT: 'Impact',
  Reg_A: 'Reg. A',
  Reg_D: 'Reg. D ',
  Reg_D_506b: 'Reg. D - 506(b)'
});